import {
  Button,
  Flex,
  SimpleGrid,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Icon,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { componentState } from "../../../../../atoms/componentState";
import {
  VARIANT,
  WHITE,
  GREENMONEDD,
  REDMONEDD,
  GRAY_DARK,
  GRAY_NEUTRAL,
  BLUEMONEDDBUTTONS,
  BLUECARD,
  ICECARD,
  GREENCARD,
  REDCARD,
} from "../../../../../constants/colors";
import {
  ExtractListCards,
  simplifiedExtract,
} from "../../../../../interfaces/defaultInterfaces";
import ExtratoApi from "../../../../../services/ExtratoAPI";

import { useSetRecoilState } from "recoil";
import DateDropdown from "../../../../../defaultComponents/dateDropdown";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../../vendas/listaDeVendas/SalesList";
import SalesListAPI from "../../../../../services/SalesListApi";
import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import CardExtract from "../../../../financeiro/extracts/defaultComponents/cardExtract";
import { FaPlay } from "react-icons/fa";
import { goToExtractClientsSupervisor } from "../../../../../routes/coordinator";
import { FaFileExport } from "react-icons/fa";
export default function SimplifiedDetailsSupervisor() {
  const navigate = useNavigate();
  const { idClient } = useParams();
  const id = Number(idClient);

  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Extrato Simplificado");
  }, []);

  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
  const dataFuturo = moment("12/12/2077")
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");

  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);

  // Razao SPLIT (tabela ExtratoSplit). O extrato acima so mostra, por linha,
  // quanto daquela venda foi splitado; o razao em si — inclusive o repasse que
  // zera o saldo — vive so deste lado.
  const [splitList, setSplitList] = useState(Array<simplifiedExtract>);
  const [splitSaldo, setSplitSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  // Vem do /ExtratoSplit/saldo, que agrupa o razao inteiro sem recorte de data:
  // dia sem lancamento continua mostrando a faixa, zerada, em vez de some-la.
  const [clienteTemSplit, setClienteTemSplit] = useState(false);

  // Ponte com a outra ponta do split. A API preenche so um dos dois campos: no
  // extrato normal vem valorExtratoSplit, no split vem valorExtratoPrincipal.
  // Cliente sem split nao recebe nenhum dos dois e as colunas nao aparecem.
  const temPrincipal = extractList.some((i) => i.valorExtratoPrincipal != null);
  const temSplitPonte = extractList.some((i) => i.valorExtratoSplit != null);
  const temPonte = temPrincipal || temSplitPonte;
  const tituloPonte = temPrincipal ? "No Extrato Principal" : "No Extrato Split";
  // percentualExtratoAtual e sempre o % que FICA no principal: a legenda
  // inverte quando estamos olhando a partir do extrato normal.
  const legendaPct = (pct: number) =>
    temPrincipal
      ? `${Number(pct).toFixed(0)}% no principal`
      : `${(100 - Number(pct)).toFixed(0)}% splitado`;
  const moeda = (v: number) =>
    v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  // Movimento do periodo no razao split, por sinal. Entradas - Saidas fecha com
  // o saldoPeriodo devolvido pelo /ExtratoSplit/saldo.
  const splitCredito = splitList
    .filter((item: any) => item?.tipoLancamento?.sinal === "C")
    .reduce((acc: number, item: any) => acc + item.valor, 0);
  const splitDebito = splitList
    .filter((item: any) => item?.tipoLancamento?.sinal === "D")
    .reduce((acc: number, item: any) => acc + item.valor, 0);
  const temSplit = clienteTemSplit || splitList.length > 0;
  // Flag propria da tabela: as quatro consultas rodam em paralelo e
  // compartilhavam o mesmo `loading`, entao a primeira a responder desligava o
  // spinner enquanto o extrato ainda vinha.
  const [carregandoLista, setCarregandoLista] = useState(true);
  // Flag propria do split, pelo mesmo motivo da de cima: as consultas rodam em
  // paralelo e o `loading` compartilhado desliga na primeira que responder.
  const [carregandoSplit, setCarregandoSplit] = useState(true);
  const [cardExtract, setCardExtract] = useState<ExtractListCards>();
  const [disable, setDisable] = useState(false);
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  // const id = Number(jwtToken.idCliente);
  const [loading, setLoading] = useState(false);

  const [saldo, setSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const [saldoFuturo, setSaldoFuturo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };
  const [filtros, setFiltros] = useState(initialValues);

  // Teto do periodo: um mes cheio. E o mesmo limite que a API aplica no export
  // (ExtratoController: "O periodo da exportacao nao pode passar de 31 dias") e,
  // sem paginacao, e ele que impede a tela de puxar o extrato inteiro de uma vez.
  const MAX_DIAS_FILTRO = 31;
  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >
    MAX_DIAS_FILTRO;

  //função que receber os dados da lista de extrato
  async function getsaldoFuturo() {
    const dataFinalFunction = moment(filtros.finalDateFilter)
      .add(1, "day")
      .format("YYYY-MM-DDT00:00:00.000");
    try {
      setLoading(true);
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        dataFinalFunction,
        dataFuturo,
        id
      );
      setSaldoFuturo({
        ...saldo,
        // periodo sem lancamento devolve lista vazia: sem a guarda, a tela
        // quebrava ao inves de mostrar zero
        saldoAnterior: response.data?.[0]?.saldoAnterior ?? 0,
        saldoPeriodo: response.data?.[0]?.saldoPeriodo ?? 0,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  async function getExtractDetails() {
    try {
      setLoading(true);
      setCarregandoLista(true);
      // Sem paginacao: a tela mostra o periodo inteiro numa lista so, e quem
      // segura o tamanho da resposta e o teto de MAX_DIAS_FILTRO no filtro de
      // data. A resposta ja traz a ponte do split resolvida.
      const response = await ExtratoApi.getExtractPerClientV2(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setExtractList(response.data || []);
      setLoading(false);
      // console.log("response", response.data);
    } catch (error) {
      setLoading(false);
      setExtractList([]);
      console.log("error", error);
    } finally {
      setCarregandoLista(false);
    }
  }
  // Extrato split do periodo, tambem sem paginacao — mesmo teto de dias do
  // extrato principal segurando o tamanho da resposta.
  async function getSplitDetails() {
    try {
      setCarregandoSplit(true);
      const response = await ExtratoApi.getSplitPerClientV2(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setSplitList(response.data || []);
    } catch (error) {
      setSplitList([]);
      console.log("error", error);
    } finally {
      setCarregandoSplit(false);
    }
  }

  async function getSplitSaldo() {
    try {
      const response = await ExtratoApi.getSplitSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      const linha = response.data?.[0];
      setClienteTemSplit(!!linha);
      setSplitSaldo({
        saldoAnterior: linha?.saldoAnterior ?? 0,
        saldoPeriodo: linha?.saldoPeriodo ?? 0,
      });
    } catch (error) {
      setClienteTemSplit(false);
      setSplitSaldo({ saldoAnterior: 0, saldoPeriodo: 0 });
      console.log("error", error);
    }
  }

  //função que preenche os cards com o saldo
  async function getSaldo() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setSaldo({
        ...saldo,
        // periodo sem lancamento devolve lista vazia: sem a guarda, a tela
        // quebrava ao inves de mostrar zero
        saldoAnterior: response.data?.[0]?.saldoAnterior ?? 0,
        saldoPeriodo: response.data?.[0]?.saldoPeriodo ?? 0,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  //função para pegar o nome do cliente
  async function getExtratcList() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractList(
        1,
        600,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id,
        ""
      );
      setCardExtract(response?.[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }

  useEffect(() => {
    getExtractDetails();
    getExtratcList();
    getsaldoFuturo();
    getSaldo();
    getSplitDetails();
    getSplitSaldo();
  }, [filtros]);

  async function Export() {
    try {
      setDisable(true);
      const response = await SalesListAPI.exportDetailedExtract(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      fileDownload(response, "extrato.xlsx");
      setDisable(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={"#F5F5F5"}
      // shadow={"xl"}
      flexDirection={"column"}
      overflowY={"auto"}
    >
      <Flex
        // width={"100%"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        flexShrink={0}
        my={4}
        ml={5}
      >
        <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
        <Flex
          // mx={4}
          // mt={4}
          color={BLUEMONEDDBUTTONS}
          fontWeight={"bold"}
          alignItems={"center"}
        >
          <Text h={"100%"} fontSize={35} mx={4}>
            Extrato
          </Text>
          <Text pt={2} h={"100%"} fontSize={20}>
            {/* Nome vem do cardExtract (/Extrato/listagem), nao do extrato:
                a rota v2 nao projeta Cliente de proposito (era o join mais caro
                da consulta). Lendo de extractList[0].cliente a tela quebrava
                assim que o periodo tinha lancamento. */}
            {loading ? (
              <Spinner />
            ) : cardExtract?.razaoSocial ? (
              cardExtract.isCnpj ? (
                cardExtract.razaoSocial
              ) : (
                `${cardExtract.razaoSocial} ${cardExtract.sobrenome ?? ""}`.trim()
              )
            ) : (
              ""
            )}
          </Text>
        </Flex>
      </Flex>
      <Flex
        w={"100%"}
        // fit-content, nao percentual: sao ~19 cards em 4 linhas e a altura
        // fixa fazia o bloco transbordar por baixo da barra de filtros
        h={"fit-content"}
        flexShrink={0}
        flexDirection={"column"}
        // pb={2}
        mb={8}
        // ml={4}
        // mx={2}
        justifyContent={"space-between"}
      >
        <SimpleGrid columns={6} spacingX={2} spacingY={1} w={"100%"} px={6}>
          <CardExtract
            value={saldo ? saldo.saldoAnterior : 0}
            bgColor={BLUECARD}
            color={"white"}
            description={`Saldo em : ${moment(filtros.initialDateFilter)
              .add(-1, "day")
              .format("DD/MM/YYYY")}`}
          />
          <CardExtract
            value={cardExtract ? cardExtract.lancamentoManualCredito : 0}
            bgColor={GREENCARD}
            color={"white"}
            description={"Lançamento de Crédito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.lancamentoManualDebito : 0}
            bgColor={REDCARD}
            color={"white"}
            description={"Lançamento de Débito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaCartao : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Crédito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract?.vendaCartaoDebito : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Débito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaBoleto : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Boletos"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaBolepix : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Bolepix"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaPix : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas PIX"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoBoleto : 0} // novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Boleto`}
          />

          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoPIX : 0} // novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Pix`}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoBolepix : 0} // novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Bolepix`}
          />



          <CardExtract
            value={cardExtract ? cardExtract.pagamentoBoleto : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Pagamentos de Boleto"}
          />

          <CardExtract
            value={cardExtract ? cardExtract.transferenciaTED : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Transferências"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoVendaCartao : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Canceladas"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.disputaVendaCartao : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"vendas em Disputa"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoRemessaBoleto : 0} //novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Remessa Boleto`}
          />
          <CardExtract
            value={
              cardExtract ? cardExtract.cancelamentoRemessaTransferencia : 0
            } //novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Remessa Transferencia`}
          />
          <CardExtract
            value={saldo ? saldo.saldoAnterior + saldo.saldoPeriodo : 0}
            bgColor={BLUEMONEDDBUTTONS}
            color={"white"}
            description={`Saldo em: ${moment(filtros.finalDateFilter).format(
              "DD/MM/YYYY"
            )}`}
          />
        </SimpleGrid>
        {/* </Flex>
        </Flex> */}

        {/* Faixa propria do split: e outro razao, e diluir estes tres cards
            entre os 18 de cima quebraria a grade de 6 colunas. */}
        {temSplit ? (
          <Flex flexDirection={"column"} w={"100%"} px={6} mt={4}>
            <Text
              fontSize={"0.7rem"}
              fontWeight={"bold"}
              color={"gray.500"}
              textTransform={"uppercase"}
              letterSpacing={"wider"}
              mb={1}
            >
              Extrato Split
            </Text>
            <SimpleGrid columns={6} spacingX={2} spacingY={1} w={"100%"}>
              <CardExtract
                value={splitCredito}
                bgColor={GREENCARD}
                color={"white"}
                description={"Entradas do Split"}
              />
              <CardExtract
                value={splitDebito}
                bgColor={REDCARD}
                color={"white"}
                description={"Saídas do Split"}
              />
              {/* saldoAnterior + saldoPeriodo: o saldo que o cliente tem no
                  razao split, e nao o liquido do periodo. */}
              <CardExtract
                value={splitSaldo.saldoAnterior + splitSaldo.saldoPeriodo}
                bgColor={BLUEMONEDDBUTTONS}
                color={"white"}
                description={`Saldo Split em: ${moment(
                  filtros.finalDateFilter
                ).format("DD/MM/YYYY")}`}
              />
            </SimpleGrid>
          </Flex>
        ) : (
          <></>
        )}
      </Flex>
      {/* Aqui sao 4 controles (o cliente tem 3, sem o "Voltar"): padding fixo de
          300px esmagava tudo em tela menor. Recuo menor + gap + wrap. */}
      <Flex
        w={"98%"}
        h={"fit-content"}
        flexShrink={0}
        py={7}
        px={{ base: 4, xl: "150px" }}
        gap={4}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <DateDropdown
          filtros={filtros}
          setFiltros={setFiltros}
          maxDias={MAX_DIAS_FILTRO}
        />
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          isDisabled={disable || dias}
          onClick={() => {
            Export();
          }}
        >
          {disable === true ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaFileExport} />
              Exportar
            </>
          )}
        </Button>
        <Button
          bgColor={GRAY_NEUTRAL}
          color={WHITE}
          onClick={() => {
            setFiltros(initialValues);
          }}
        >
          Limpar Filtros
        </Button>

        <Button
          bgColor={GRAY_NEUTRAL}
          color={WHITE}
          onClick={() => {
            goToExtractClientsSupervisor(navigate);
          }}
        >
          Voltar
        </Button>
      </Flex>
      {carregandoLista ? (
        <Flex
          w={"100%"}
          minH={"45vh"}
          flexShrink={0}
          alignItems={"center"}
          justifyContent={"center"}
          px={2}
          flexDirection="column"
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"45vh"}
          minH={"45vh"}
          flexShrink={0}
          alignItems={"flex-start"}
          px={2}
          flexDirection="column"
          overflowY={"auto"}
        >
          <Table variant={"striped"} fontSize={"0.8rem"}>
            <Thead
              h="50px"
              position="sticky"
              top="0"
              bgColor={BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  // w={"300px"}
                  fontWeight={"bold"}
                  borderRadius={"8px 0 0 8px"}
                  // textAlign={"center"}
                  bgColor={"none"}
                  // color={BLUEMONEDDBUTTONS}
                  color={"white"}
                  fontSize={"11px"}
                  w={"9vw"}
                >
                  Data de Lançamento
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"10vw"}>
                  Tipo de Lançamento
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"16vw"}>
                  Id da Venda
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                  Data de Venda
                </Th>
                {/* <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                  Status
                </Th> */}
                <Th color={"white"} fontSize={"11px"} w={"10vw"}>
                  Pagador
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Nro da Parcela
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  valor Bruto
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Taxa Cliente
                </Th>
                {/* <Th color={"white"}>Tipo de Venda</Th> */}
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Valor
                </Th>
                {temPonte ? (
                  <>
                    <Th color={"white"} fontSize={"11px"} w={"7vw"}>
                      {tituloPonte}
                    </Th>
                    <Th color={"white"} fontSize={"11px"} w={"7vw"}>
                      Líquido Total
                    </Th>
                  </>
                ) : (
                  <></>
                )}

                <Th
                  color={"white"}
                  borderRadius={"0 8px 8px 0"}
                  fontSize={"11px"}
                  w={"7vw"}
                >
                  Saldo
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {extractList &&
                extractList.map((item, index) => {
                  // console.log("item", item);
                  return (
                    <Tr key={index}>
                      <Td
                        borderRadius={"8px 0px 0px 8px"}
                        fontSize="12px"
                        w={"10vw"}
                      >
                        {moment(item?.dataLancamento).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      <Td fontSize="12px" w={"8vw"}>
                        {item?.tipoLancamento?.lancamento
                          ? item?.tipoLancamento?.lancamento
                          : null}
                      </Td>
                      <Td fontSize="12px" w={"10vw"}>
                        {item.transacao?.idTransacao &&
                          item.transacao?.idTransacao}
                      </Td>
                      <Td fontSize="12px" w={"12vw"}>
                        {item.transacao?.dataCriacao &&
                          moment(item.transacao?.dataCriacao).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                      </Td>
                      {/* <Td fontSize="12px" w={"8vw"}>
                        {item.transacao?.statusVenda?.status
                          ? item.transacao?.statusVenda?.status
                          : item.transacao?.status
                          ? item.transacao?.status
                          : ""}
                      </Td> */}
                      <Td fontSize="12px" w={"10vw"}>
                        {item.transacao?.clienteNome &&
                          item.transacao?.clienteNome}
                      </Td>
                      <Td fontSize="12px">
                        {item.parcela
                          ? `${item.parcela}/${item.nroParcelas}`
                          : ``}
                      </Td>
                      <Td fontSize="12px" w={"6vw"}>
                        {item?.transacao &&
                          item?.transacao?.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Td>
                      <Td color={REDMONEDD} fontSize="12px" w={"6vw"}>
                        {item?.transacao &&
                          item?.transacao?.taxaCliente.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Td>
                      {/* <Td>
                      {item.transacao?.produto.nome &&
                        item.transacao?.produto.nome}
                    </Td> */}
                      {(item?.tipoLancamento?.sinal === "C" && (
                        <Td color={GREENMONEDD} fontSize="12px" w={"6vw"}>
                          {" "}
                          {item?.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                      )) ||
                        (item?.tipoLancamento?.sinal === "D" && (
                          <Td color={REDMONEDD} fontSize="12px" w={"6vw"}>
                            {" "}
                            {item?.valor.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Td>
                        )) ||
                        (item?.tipoLancamento?.sinal === "X" && (
                          <Td color={GRAY_DARK} fontSize="12px" w={"6vw"}>
                            {"-- --"}
                          </Td>
                        )) ||
                        null}
                      {temPonte ? (
                        <>
                          <Td fontSize="12px" w={"7vw"}>
                            {(item.valorExtratoPrincipal ??
                              item.valorExtratoSplit) != null ? (
                              <>
                                {moeda(
                                  (item.valorExtratoPrincipal ??
                                    item.valorExtratoSplit) as number
                                )}
                                {item.percentualExtratoAtual != null ? (
                                  <Text fontSize={"0.65rem"} color={"gray.500"}>
                                    {legendaPct(item.percentualExtratoAtual)}
                                  </Text>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              "—"
                            )}
                          </Td>
                          <Td fontSize="12px" w={"7vw"}>
                            {item.valorLiquidoTotal != null
                              ? moeda(item.valorLiquidoTotal)
                              : "—"}
                          </Td>
                        </>
                      ) : (
                        <></>
                      )}
                      <Td
                        borderRadius={"0 8px 8px 0"}
                        fontSize="12px"
                        w={"6vw"}
                      >
                        {item?.saldo === 0
                          ? "R$ 0,00"
                          : item?.saldo?.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Td>
                    </Tr>
                  );
                })}
              {extractList.length === 0 ? (
                <Tr>
                  <Td colSpan={temPonte ? 11 : 9} textAlign="center" py={8}>
                    <Text color={"gray.500"} fontSize={"0.85rem"}>
                      Nenhum lançamento no período selecionado.
                    </Text>
                  </Td>
                </Tr>
              ) : (
                <></>
              )}
            </Tbody>
          </Table>
        </Flex>
      )}

      {/* ── Extrato corrido do razao SPLIT ──────────────────────────────────
          Mesma leitura da tabela de cima (corrido, com saldo por linha), sobre a
          ExtratoSplit. O saldo vem calculado da API, entao a lista traz TODAS as
          linhas do periodo: filtrar por tipo aqui faria a coluna de saldo pular
          sem explicacao. */}
      {temSplit ? (
        <Flex
          w={"100%"}
          h={"fit-content"}
          flexShrink={0}
          flexDirection={"column"}
          px={2}
          mb={6}
        >
          <Flex px={4} py={2} alignItems={"baseline"} gap={3}>
            <Text fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              Extrato Split
            </Text>
            {/* Os totais so aparecem com a lista pronta: enquanto carrega, eles
                seriam os do periodo anterior. */}
            {carregandoSplit ? (
              <Text fontSize={"0.75rem"} color={"gray.500"}>
                carregando…
              </Text>
            ) : (
              <Text fontSize={"0.75rem"} color={"gray.500"}>
                {splitList.length} lançamento
                {splitList.length === 1 ? "" : "s"} no período · entradas{" "}
                {moeda(splitCredito)} · saídas {moeda(splitDebito)}
              </Text>
            )}
          </Flex>

          {carregandoSplit ? (
            <Flex
              w={"100%"}
              minH={"20vh"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Spinner size={"lg"} color={VARIANT} />
            </Flex>
          ) : (
          <Flex
            w={"100%"}
            maxH={"45vh"}
            alignItems={"flex-start"}
            flexDirection="column"
            overflowY={"auto"}
          >
            <Table variant={"striped"} fontSize={"0.8rem"}>
              <Thead
                h="50px"
                position="sticky"
                top="0"
                bgColor={BLUEMONEDDBUTTONS}
              >
                <Tr>
                  <Th
                    fontWeight={"bold"}
                    borderRadius={"8px 0 0 8px"}
                    color={"white"}
                    fontSize={"11px"}
                    w={"12vw"}
                  >
                    Data de Lançamento
                  </Th>
                  <Th color={"white"} fontSize={"11px"} w={"14vw"}>
                    Tipo de Lançamento
                  </Th>
                  <Th color={"white"} fontSize={"11px"} w={"16vw"}>
                    Id da Venda
                  </Th>
                  <Th color={"white"} fontSize={"11px"} w={"20vw"}>
                    Descrição
                  </Th>
                  <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                    Valor
                  </Th>
                  <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                    No Extrato Principal
                  </Th>
                  <Th
                    color={"white"}
                    borderRadius={"0 8px 8px 0"}
                    fontSize={"11px"}
                    w={"8vw"}
                  >
                    Saldo
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {splitList.map((item: any, index: number) => (
                  <Tr key={index}>
                    <Td borderRadius={"8px 0px 0px 8px"} fontSize="12px">
                      {moment(item?.dataLancamento).format("DD/MM/YYYY HH:mm")}
                    </Td>
                    <Td fontSize="12px">
                      {item?.tipoLancamento?.lancamento ?? ""}
                    </Td>
                    <Td fontSize="12px">{item?.transacao?.idTransacao ?? ""}</Td>
                    <Td fontSize="12px">{item?.observacao ?? ""}</Td>
                    <Td
                      fontSize="12px"
                      color={
                        item?.tipoLancamento?.sinal === "C"
                          ? GREENMONEDD
                          : item?.tipoLancamento?.sinal === "D"
                          ? REDMONEDD
                          : GRAY_DARK
                      }
                    >
                      {item?.tipoLancamento?.sinal === "X"
                        ? "-- --"
                        : moeda(item?.valor)}
                    </Td>
                    <Td fontSize="12px">
                      {item?.valorExtratoPrincipal != null
                        ? moeda(item.valorExtratoPrincipal)
                        : "—"}
                    </Td>
                    <Td borderRadius={"0 8px 8px 0"} fontSize="12px">
                      {item?.saldo != null ? moeda(item.saldo) : "—"}
                    </Td>
                  </Tr>
                ))}
                {splitList.length === 0 ? (
                  <Tr>
                    <Td colSpan={7} textAlign="center" py={8}>
                      <Text color={"gray.500"} fontSize={"0.85rem"}>
                        Nenhum lançamento no extrato split neste período.
                      </Text>
                    </Td>
                  </Tr>
                ) : (
                  <></>
                )}
              </Tbody>
            </Table>
          </Flex>
          )}
        </Flex>
      ) : (
        <></>
      )}

    </Flex>
  );
}
